import * as React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import * as types from "../../constants/actionTypes";
import DataComponent from "../common/DataComponent";

import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

import Cookies from "cookies-js";
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { isLoggedIn } from "../../api/ssoApi";

import MiniSpinner from "../common/MiniSpinner";
import spinner from "../common/spinner";

import GenericInput from "../common/input/GenericInput";

const Interactive_InApp_Tutorial = 'InteractiveInAppTutorial';  //cookie name for Interactive In App Site Tour

/**
 * Container component for the dashboard page.
 * 
 */
class SearchResults extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showAsInvalid: false,
            workingSearchTerm: null
        };
        this.buttonClick = this.buttonClick.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        if (this.props.isLoggedIn) {
            logUI("MBHWeb.UI.SearchResults.ComponentDidMount", new Date(), Tools.getURLPath());
        }
    }

    componentDidCatch(ex, info) {
        let json = { error: ex, componentStack: info };
        logUI("MBHWeb.UI.SearchResults.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(json));
    }

    buttonClick() {
        var searchTerm = this.state.workingSearchTerm;
        if (searchTerm !== "") {
            this.setState({ workingSearchTerm: null });
            this.props.search(searchTerm, this.props.authToken);

        } else {
            this.setState({ showAsInvalid: true });
        }
    }

    keyPress(e) {
        if (e.charCode === 13) {
            this.buttonClick();
        }
    }

    onChange(e) {
        var searchTerm = e.target.value;
        this.setState({ workingSearchTerm: searchTerm });
        if (searchTerm !== "") {
            this.setState({ showAsInvalid: false });
        }
    }

    render() {
        var isClientSide = typeof window !== 'undefined';
        var { searchResults, searching, searchLastTerm } = this.props;
        var { workingSearchTerm } = this.state;

        var inputSearchTerm = workingSearchTerm === null ? searchLastTerm : workingSearchTerm;

        var hasSearchResults = searchResults ? true : false;
        var hasResults = searchResults ? searchResults.length > 0 : false;

        let searchResultsMarkup = [];

        if (hasSearchResults && hasResults) {
            searchResultsMarkup = searchResults.map((result, index) => {
                return (
                    <div key={index} className="site-search-results__item">
                        <h3><Link to={{ pathname: result.route }}>{result.routeTitle}</Link></h3>
                        <p>{result.routeDescription}</p>
                    </div>
                );
            });
        }

        try {

            return (
                <div className="container-fluid body-content site-search-results-container">
                    {/*<div className="row">
                        <div className="col-12">
                            <h1 className="page-heading">Site Search Test</h1>
                        </div>
                    </div>*/}

                    <div className="row site-search-results__form">
                        <div className="col-12 form-group minimal-style">

                            <GenericInput
                                value={inputSearchTerm}
                                ref="inputSearch" onKeyPress={this.keyPress} onChange={this.onChange}
                                inputBtnClick={this.buttonClick} inputBtnIcon="icon-search" inputBtnLabel="Search"
                                placeholder="Search Site" inputErrorMsg="Please enter a search term."
                                showAsInvalid={this.state.showAsInvalid} showClearBtn
                            />
                        </div>
                        {/*<div className="col-12 col-sm-4 form-group">
                            <button className="btn btn-primary" onClick={this.buttonClick}>Search</button>
                        </div>*/}
                    </div>
                    <div className="row site-search-results__list">
                        <div className="col-12">
                            {searching && <MiniSpinner />}
                            <React.Fragment>
                                {
                                    (!hasSearchResults ? "" :
                                        (!hasResults ?
                                            <React.Fragment>
                                                <h2>Results for <span className="site-search-term">'{searchLastTerm}'</span></h2>
                                                <p className="no-results-container">We were unable to find results for '{searchLastTerm}'.</p>
                                            </React.Fragment> :
                                            <React.Fragment>
                                                <h2>Results for <span className="site-search-term">'{searchLastTerm}'</span></h2>
                                                {
                                                    searchResultsMarkup
                                                }
                                            </React.Fragment>
                                        )
                                    )
                                }
                            </React.Fragment>
                        </div>
                    </div>
                </div>
            );

        }
        catch (ex) {
            console.error(ex);
            return <div>Exception rendering!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! {ex}</div>;
        }
    }
}

const mapStateToProps = (state) => {
    //debugger;

    return {
        userDetails: state.sso.userDetails,
        isLoggedIn: state.domain.li,
        hasMyChartLogin: !state.common.epicEHRDown && state.domain.hm,
        authToken: state.domain.t,
        isProxyUser: state.domain.ip,
        isEmployee: state.domain.ie,
        searchResults: state.portal.searchResults,
        searchError: state.portal.searchError,
        searching: state.portal.searching,
        searchSuccess: state.portal.searchSuccess,
        searchFailure: state.portal.searchFailure,
        searchLastTerm: state.portal.searchLastTerm,
        fluConsent: state.domain.fc
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        search: (searchPhrase, token) => {
            dispatch({
                type: types.SITE_SEARCH_START, searchPhrase: searchPhrase, token: token
            });
        }
    };
};


const SearchResultsComp = withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchResults));

export default SearchResultsComp;